module.exports = __webpack_public_path__ + "static/media/DftAframe.3313fddc.webp";